<template>
    <header class="header-component">
        <DxToolbar class="header-toolbar">
            <DxItem
                :visible="menuToggleEnabled"
                location="before"
                css-class="menu-button"
            >
                <template #default>
                    <dx-button
                        icon="menu"
                        styling-mode="text"
                        @click="toggleMenuFunc"
                    />
                </template>
            </DxItem>

            <DxItem
                location="before"
            >
                <img alt="logo" :height="24" src="assets/logo/mo_logo.svg"/>
            </DxItem>

            <DxItem location="after">
                <div>
                    <theme-switcher/>
                </div>
            </DxItem>

            <DxItem
                location="after"
                locate-in-menu="auto"
                menu-item-template="menuUserItem"
            >
                <template #default>
                    <UserPanel :menu-items="userMenuItems" menuMode="context"/>
                </template>
            </DxItem>

            <template #menuUserItem>
                <UserPanel :menu-items="userMenuItems" menuMode="list"/>
            </template>

        </DxToolbar>
    </header>
</template>

<script>
import DxButton from "devextreme-vue/button";
import DxToolbar, {DxItem} from "devextreme-vue/toolbar";
import auth from "../auth";
import {useRouter, useRoute} from 'vue-router';

import UserPanel from "./user-panel";
import ThemeSwitcher from './theme-switcher.vue';

export default {
    props: {
        menuToggleEnabled: Boolean,
        title: String,
        toggleMenuFunc: Function,
        logOutFunc: Function
    },
    setup() {
        const router = useRouter();
        const route = useRoute();

        const userMenuItems = [{
            text: "Profile",
            icon: "fal fa-user",
            onClick: onProfileClick
        },
            {
                text: "Logout",
                icon: "fal fa-power-off",
                onClick: onLogoutClick
            }];

        function onLogoutClick() {
            auth.logOut();
            router.push({
                path: "/login-form",
                query: {redirect: route.path}
            });
        }

        function onProfileClick() {
            router.push({
                path: "/profile",
                query: {redirect: route.path}
            });
        }

        return {
            userMenuItems
        };
    },
    components: {
        ThemeSwitcher,
        DxButton,
        DxToolbar,
        DxItem,
        UserPanel
    }
};
</script>

<style lang="scss">
@import "../dx-styles.scss";

header {
    background-color: var(--base-bg);
}

.header-component {
    height: 46px;
    align-content: center;
    flex: 0 0 auto;
    z-index: 1;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.12), 0 0 2px rgba(0, 0, 0, 0.24);
}

.dx-toolbar.header-toolbar .dx-toolbar-items-container .dx-toolbar-after {
    padding: 0 20px;

    .screen-x-small & {
        padding: 0 20px;
    }
}

.dx-toolbar .dx-toolbar-item.dx-toolbar-button.menu-button {
    width: $side-panel-min-width;
    text-align: center;
    padding: 0;
}

.header-title .dx-item-content {
    padding: 0;
    margin: 0;
}

.dx-theme-generic {
    .dx-toolbar {
        padding: 10px 0;
    }

    .user-button > .dx-button-content {
        padding: 3px;
    }
}
</style>
